export default class RangesMenu {
	static init() {
		const rangesMenuEls = [ ...document.querySelectorAll(".ranges-menu") ];

		if (rangesMenuEls.length === 0) {
			return;
		}

		rangesMenuEls.forEach((rangeMenu) => {
			const rangesItems = [ ...rangeMenu.querySelectorAll('.range-link') ];

			rangesItems.forEach((range) => {
				const { rangeName } = range.dataset;
				const rangeImg = rangeMenu.querySelector(`.range-img[data-range-name='${rangeName}']`);

				[ 'mouseenter', 'focus' ].forEach((evt) => {
					range.addEventListener(evt, () => {
						rangeImg.classList.add('active');
					});
				});

				[ 'mouseleave', 'blur' ].forEach((evt) => {
					range.addEventListener(evt, () => {
						rangeImg.classList.remove('active');
					});
				});
			});
		});
	}
}